import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { InformationSuccess } from './informationSuccess';
import { Routes } from '../../../store/routes';
import { InformationFailed } from './informationFailed';

export const InformationRoutes = () => (
  <Route
    render={({ location }) => (
      <Switch location={location}>
        <Route exact path={Routes.InformationSuccess} component={InformationSuccess} />
        <Route exact path={Routes.InformationError} component={InformationFailed} />
      </Switch>
    )}
  />
);
